import { Controller } from '@hotwired/stimulus';

// Puts a plain-language message in the browser's own validation bubble for a required field. Setting it needs
// setCustomValidity from script; there is no attribute for it, and inline handlers are blocked by the CSP.
// Shared by Virtualtrails and Wild Steps; wire it with the `validity_message` view helper.
export default class ValidityMessageController extends Controller<HTMLInputElement> {
  public static readonly values = { message: String };

  declare private readonly messageValue: string;

  public explain(): void {
    this.element.setCustomValidity(this.messageValue);
  }

  public reset(): void {
    this.element.setCustomValidity('');
  }
}
